import { render, staticRenderFns } from "./GestorPermiso.vue?vue&type=template&id=fe8bc1c6&scoped=true"
import script from "./GestorPermiso.vue?vue&type=script&lang=js"
export * from "./GestorPermiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8bc1c6",
  null
  
)

export default component.exports